export enum BaseDataTax {
  INLAND = 'INLAND',
  EU = 'EU',
  DRITTLAND = 'DRITTLAND',
}
